import { CardButton, CircularFrame, Icon, Typography } from '@pinwheel/origami';
import React from 'react';
import CompanyIcon from './CompanyIcon';
var SearchProviderButton = function (_a) {
    var provider = _a.provider, eventId = _a.eventId, defaultIcon = _a.defaultIcon, onClick = _a.onClick, dataTestId = _a["data-testid"];
    // Apply an accessible name to the button container. Since the label (platform name)
    // is already present on the DOM, use `aria-labelledby` instead of `aria-label`.
    var labelId = "SearchProviderButton-platform-".concat(provider.id);
    return (React.createElement(CardButton, { "data-testid": dataTestId, onClick: function () { return onClick(provider); }, sx: { padding: 0, marginTop: '8px' }, eventId: eventId, "aria-labelledby": labelId, wrapHtmlTag: "div" },
        React.createElement("div", { style: {
                padding: '8px',
                display: 'flex',
                alignItems: 'center',
            } },
            provider.logoUrl ? (React.createElement(CompanyIcon, { result: {
                    id: provider.id,
                    logoUrl: provider.logoUrl,
                    name: provider.name,
                } })) : (React.createElement(CircularFrame, { loading: false, size: "sm", backgroundColorInner: {
                    type: 'theme',
                    colorLegacy: 'Neutral/50',
                    colorNext: 'neutral/default',
                    opacityNext: 0.7,
                } },
                React.createElement(Icon, { icon: defaultIcon, size: 24, color: {
                        type: 'theme',
                        colorLegacy: 'Neutral/0',
                        colorNext: 'background/default',
                    } }))),
            React.createElement(Typography, { sx: { marginLeft: '8px' }, weight: "normal", variant: "label", align: "left", id: labelId }, provider.name))));
};
export default SearchProviderButton;
